import DailyAggregateTable, { type DailyAggregateConfig } from '../../components/DailyAggregateTable';
import { LocalStorageKeys } from '../../util/constants';

const SUPPLY_PAYMENT_MODE_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.SUPPLY_PAYMENT_MODE_RECORDS,
	headerKey: 'common:payments.headers.supplyByMode',
	endpoint: 'supplier-payments/modes',
	exportPrefix: 'supply_payments_by_mode',
	dimensionKey: 'mode',
	dimensionHeaderKey: 'common:tables.mode',
	extraColumns: [
		{ accessorKey: 'user', headerKey: 'common:tables.user' },
	],
	enableSupplyPaymentCreate: true,
};

const SUPPLY_PAYMENT_USER_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.SUPPLY_PAYMENT_USER_RECORDS,
	headerKey: 'common:payments.headers.supplyByUser',
	endpoint: 'supplier-payments/users',
	exportPrefix: 'supply_payments_by_user',
	dimensionKey: 'user',
	dimensionHeaderKey: 'common:tables.user',
	enableSupplyPaymentCreate: true,
};

const SUPPLY_PAYMENT_DEPOT_CONFIG: DailyAggregateConfig = {
	storageKey: LocalStorageKeys.SUPPLY_PAYMENT_DEPOT_RECORDS,
	headerKey: 'common:payments.headers.supplyByDepot',
	endpoint: 'supplier-payments/depots',
	exportPrefix: 'supply_payments_by_depot',
	dimensionKey: 'depot',
	dimensionHeaderKey: 'common:tables.depot',
	enableSupplyPaymentCreate: true,
};

export const SupplyPaymentModeDaily = () => <DailyAggregateTable config={SUPPLY_PAYMENT_MODE_CONFIG} />;
export const SupplyPaymentUserDaily = () => <DailyAggregateTable config={SUPPLY_PAYMENT_USER_CONFIG} />;
export const SupplyPaymentDepotDaily = () => <DailyAggregateTable config={SUPPLY_PAYMENT_DEPOT_CONFIG} />;